import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { RUN_CHAT_MESSAGES_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { run_chat_messages_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useRunId from '@/hooks/useRunId.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { ChatMessages } from '@/types/runs.ts';

const useRetrieveRunChatMessages = (): UseQueryResult<ChatMessages, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const runId = useRunId();

  return useQuery({
    queryKey: RUN_CHAT_MESSAGES_KEY(automationId, runId),
    queryFn: async () => {
      const response = await apiClient.get(run_chat_messages_url(runId));
      return response.data;
    },
  });
};

export default useRetrieveRunChatMessages;
